export const appsAppGroupIdChartsRevenueLifetimeStats = "/apps/:app_group_id/charts/revenue/lifetime_stats";
